export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/calendar-check-02.9e955c1c.svg","height":24,"width":25,"blurWidth":0,"blurHeight":0};